import {
  useApiAdminsalesHierarchiesGetCollection,
  getApiAdminsalesHierarchiesGetCollectionQueryKey
} from '@r/api/generated/client.ts';
import { useTranslation } from 'react-i18next';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';

/** Liste des hiérarchies commerciales du workspace actif (pas de pagination côté API). */
export const useSalesHierarchies = () => {
  const { t } = useTranslation();
  const hierarchiesQuery = useApiAdminsalesHierarchiesGetCollection({
    query: {
      queryKey: getApiAdminsalesHierarchiesGetCollectionQueryKey()
    }
  });
  useOrvalQueryErrorToast(hierarchiesQuery, t('toast.error.label'));

  const {
    data: hierarchies,
    isLoading: isHierarchiesLoading,
    isSuccess: isHierarchiesSuccess,
    refetch: refetchHierarchies
  } = hierarchiesQuery;

  return {
    hierarchies,
    isHierarchiesLoading,
    isHierarchiesSuccess,
    refetchHierarchies
  };
};
